import React from 'react'
import CodeCard from "../CodeCard/CodeCard";
import './style.css'
import {Collapse, ExpansionPanel, ExpansionPanelSummary, Paper, Typography, withStyles} from "@material-ui/core";
import DetailsCard from "../DetailsCard/DetailsCard";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from "prop-types";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

const styles = theme => ({
    ...cardStyles,
    bucketsContainer: {
        padding: theme.spacing.unit / 2,
        justifyContent: 'center',
        borderRadius: 0
    },
    buckets: {
        padding: theme.spacing.unit / 2,
        justifyContent: 'center',
        background: "#FFF",
        borderRadius: 0
    },
    bucketsDetails: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-around',
        width: '90%',
        background: '#ffffff'
    },
    media: {
        '& div': {
            "@media screen and (max-width: 1199px)": {
                margin: '0',
            }  
        }
    },
})

class EntityExtractionOutputs extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            isPopulationCollapsed: false ,
            isSubjectsCollapsed: false,
            isPeopleCollapsed: false,
            isOrganizationsCollapsed: false,
            isGeographiesCollapsed: false,
        }
        this.codeMapping = this.codeMapping.bind(this);
        this.detailsMapping = this.detailsMapping.bind(this);
        this.detailstestMapping = this.detailstestMapping.bind(this)
    }

    codeMapping = (codes) => {
        return codes.map(el => <CodeCard key={el.full_code} code={el.code} fullCode={el.full_code} description={el.description} isControlRequired={this.props.isControlRequired}/>)
    }

    detailsMapping = (people) => {
        return people.map(el => <DetailsCard key={el} isControlRequired={this.props.isControlRequired} field={el}/>);
    }

    detailstestMapping = (people) => {
        return people.map(el => <DetailsCard key={el.salience} isControlRequired={this.props.isControlRequired} silent={el.salience} field={el.name}/>);
    }

    geosMapping = (geo_ids) => {
        return geo_ids.map(el => <DetailsCard key={el.geonameid} isControlRequired={this.props.isControlRequired} field={el.name}/>)
    }

    render() {
        return (
            <div className="outputs-block">
                { this.props.population && this.props.population.length !== 0 &&
                    <Paper elevation={0} className={this.props.classes.bucketsContainer}>
                        <ExpansionPanel className={this.props.classes.buckets} onClick={e => this.setState({isPopulationCollapsed: !this.state.isPopulationCollapsed})}>
                            <ExpansionPanelSummary style={{fill: '#000000'}} className={this.props.classes.media}>
                                <Typography variant="title" gutterBottom style={{ color: "#000000" }} className='heading'>
                                    Population ({this.props.population.length})<ExpandMoreIcon/>
                                </Typography>
                            </ExpansionPanelSummary>
                            <Collapse in={this.state.isPopulationCollapsed}>
                                {this.codeMapping(this.props.population)}
                            </Collapse>
                        </ExpansionPanel>
                    </Paper> 
                }

                {this.props.subjects && this.props.subjects.length !== 0 &&
                    <Paper elevation={0} className={this.props.classes.bucketsContainer}>
                        <ExpansionPanel className={this.props.classes.buckets} onClick={e => this.setState({isSubjectsCollapsed: !this.state.isSubjectsCollapsed})}>
                            <ExpansionPanelSummary style={{fill: '#000000'}}>
                                <Typography variant="title" gutterBottom style={{ color: "#000000" }} className='heading'>
                                    Subjects ({this.props.subjects.length})<ExpandMoreIcon/>
                                </Typography>
                            </ExpansionPanelSummary>
                            <Collapse in={this.state.isSubjectsCollapsed}>
                                {this.codeMapping(this.props.subjects)}
                            </Collapse>
                        </ExpansionPanel>
                    </Paper> 
                }
                {this.props.people && this.props.people.length !== 0 &&
                    <Paper elevation={0} className={this.props.classes.bucketsContainer}>
                        <ExpansionPanel className={this.props.classes.buckets} onClick={e => this.setState({isPeopleCollapsed: !this.state.isPeopleCollapsed})}>
                            <ExpansionPanelSummary style={{fill: '#000000'}}>
                                <Typography variant="title" gutterBottom style={{ color: "#000000" }} className='heading'>
                                    People ({this.props.people.length}) <ExpandMoreIcon/>
                                </Typography>
                            </ExpansionPanelSummary>
                            <Collapse in={this.state.isPeopleCollapsed}>
                                {this.detailsMapping(this.props.people)}
                            </Collapse>
                        </ExpansionPanel>
                    </Paper> 
                }
                {this.props.organizations && this.props.organizations.length !== 0 &&
                    <Paper elevation={0} className={this.props.classes.bucketsContainer}>
                        <ExpansionPanel className={this.props.classes.buckets} onClick={e => this.setState({isOrganizationsCollapsed: !this.state.isOrganizationsCollapsed})}>
                            <ExpansionPanelSummary style={{fill: '#000000'}}>
                                <Typography variant="title" gutterBottom style={{ color: "#000000" }} className='heading'>
                                    Organizations ({this.props.organizations.length}) <ExpandMoreIcon/>
                                </Typography>
                            </ExpansionPanelSummary>
                            <Collapse in={this.state.isOrganizationsCollapsed}>
                                {this.detailstestMapping(this.props.organizations)}
                            </Collapse>
                        </ExpansionPanel>
                    </Paper> 
                }
                {this.props.geos && this.props.geos.length !== 0 &&
                    <Paper elevation={0} className={this.props.classes.bucketsContainer}>
                        <ExpansionPanel className={this.props.classes.buckets} onClick={e => this.setState({isGeographiesCollapsed: !this.state.isGeographiesCollapsed})}>
                            <ExpansionPanelSummary style={{fill: '#000000'}}>
                                <Typography variant="title" gutterBottom style={{ color: "#000000" }} className='heading'>
                                    Geographies ({this.props.geos.length}) <ExpandMoreIcon/>
                                </Typography>
                            </ExpansionPanelSummary>
                            <Collapse in={this.state.isGeographiesCollapsed}>
                                {this.geosMapping(this.props.geos)}
                            </Collapse>
                        </ExpansionPanel>
                    </Paper> 
                }
            </div>
        )
    }
}

EntityExtractionOutputs.propTypes = {
    isControlRequired: PropTypes.bool,
    organizations: PropTypes.array,
    population: PropTypes.array,
    geos: PropTypes.array,
    people: PropTypes.array,
    subjects: PropTypes.array,
    classes: PropTypes.object,
}

export default withStyles(styles)(EntityExtractionOutputs);


// WEBPACK FOOTER //
// ./src/components/EntityExtractionOutputs/EntityExtractionOutputs.jsx